import { ArrowRight, FileSearch, MessageSquare, Sparkles } from "lucide-react";
import type { FileChatThread } from "../lib/chatStore";
import { threadHasResolvableFile } from "../lib/documentCache";

type Props = {
  threads: FileChatThread[];
  activeChatId?: string | null;
  onOpenChat: (thread: FileChatThread) => void;
  onReopenFile: (thread: FileChatThread) => void;
  onClose: () => void;
};

function formatWhen(iso: string): string {
  try {
    return new Date(iso).toLocaleString("fa-IR");
  } catch {
    return iso;
  }
}

export function ChatListPage({
  threads,
  activeChatId,
  onOpenChat,
  onReopenFile,
  onClose,
}: Props) {
  return (
    <div className="chat-list-page consumer-shell">
      <header className="list-page-hero">
        <button type="button" className="text-back" onClick={onClose}>
          <ArrowRight size={16} />
          بازگشت
        </button>
        <div className="list-page-hero-copy">
          <span className="consumer-kicker">
            <MessageSquare size={14} />
            گفتگوهای ذخیره‌شده
          </span>
          <h1>تاریخچه گفتگوها</h1>
          <p>گفتگوهای وابسته به فایل‌ها را باز کنید یا فایل مرتبط را دوباره در reader بالا بیاورید.</p>
        </div>
      </header>
      {threads.length === 0 ? (
        <div className="dashboard-empty">
          <p>هنوز گفتگویی ذخیره نشده است.</p>
        </div>
      ) : (
        <ul className="chat-list">
          {threads.map((t) => {
            const hasFile = threadHasResolvableFile(t);
            return (
              <li
                key={t.id}
                className={`chat-list-item${t.id === activeChatId ? " active" : ""}`}
              >
                <button
                  type="button"
                  className="chat-list-main"
                  onClick={() => onOpenChat(t)}
                >
                  <Sparkles size={16} />
                  <div>
                    <div className="chat-list-title">{t.fileName}</div>
                    <div className="chat-list-meta">
                      {t.messages.length.toLocaleString("fa-IR")} پیام ·{" "}
                      {formatWhen(t.updatedAt)}
                      {!hasFile ? " · فایل در دسترس نیست" : ""}
                    </div>
                  </div>
                </button>
                <button
                  type="button"
                  className="icon-btn compact chat-reopen"
                  title={hasFile ? "باز کردن فایل مرتبط" : "فایل در دسترس نیست"}
                  disabled={!hasFile}
                  onClick={() => onReopenFile(t)}
                >
                  <FileSearch size={16} />
                  فایل
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
